import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

const COLORS = { green: "#10B981", yellow: "#F59E0B", red: "#EF4444" };

export const StatusDonut = ({ mix }) => {
  if (!mix) return null;
  const total = mix.data.reduce((a, d) => a + d.value, 0);
  return (
    <div data-testid="status-donut" className="rounded-xl border bg-card p-4 sm:p-5 shadow-sm">
      <h3 className="font-heading text-base sm:text-lg font-semibold">{mix.title}</h3>
      <p className="text-xs text-muted-foreground">Sebaran {total} unit menurut status capaian</p>
      <div className="relative mt-2 h-60">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie data={mix.data} dataKey="value" nameKey="name" innerRadius="58%" outerRadius="85%" paddingAngle={2}>
              {mix.data.map((d) => <Cell key={d.status} fill={COLORS[d.status]} />)}
            </Pie>
            <Tooltip contentStyle={{ borderRadius: 10, fontSize: 12 }} />
          </PieChart>
        </ResponsiveContainer>
        <div className="pointer-events-none absolute inset-0 grid place-items-center">
          <span className="font-num text-2xl font-bold">{total}</span>
        </div>
      </div>
      <div className="flex justify-center gap-4 text-xs">
        {mix.data.map((d) => (
          <span key={d.status} className="flex items-center gap-1.5"><span className="h-2 w-2 rounded-full" style={{ background: COLORS[d.status] }} />{d.name}: <b className="font-num">{d.value}</b></span>
        ))}
      </div>
    </div>
  );
};
